import { render, staticRenderFns } from "./SettingsDelivery.vue?vue&type=template&id=71301752&scoped=true"
import script from "./SettingsDelivery.vue?vue&type=script&lang=js"
export * from "./SettingsDelivery.vue?vue&type=script&lang=js"
import style0 from "./SettingsDelivery.vue?vue&type=style&index=0&id=71301752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71301752",
  null
  
)

export default component.exports